import React, { FC } from 'react';

import colors from '../../assets/colors';
import { Typography } from '../typography';
import copySvg from '../../assets/images/table-copy.svg';
import { Tooltip } from '@mui/material';

const TableItem: FC<any> = ({ item, highlight, titles }) => {
	const RE_URL =
		/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/gm;
	const RE_PHONE = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/gm;
	const RE_EMAIL = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/gm;

	const renderText = (text: string, color: keyof typeof colors) => (
		<Typography color={color} size="normal" type="tableItem" text={text} />
	);

	const renderEmail = (email: string) => (
		<Tooltip title={email} arrow>
			<div
				style={{ display: 'flex', cursor: 'pointer', alignItems: 'center' }}
				onClick={() => {
					navigator.clipboard.writeText(email).then(() => {});
				}}
			>
				<a style={{ marginRight: 10 }} href={`mailto:${email}`}>
					{renderText(email, 'black')}
				</a>
				<img src={copySvg} style={{ height: 18 }} alt="" />
			</div>
		</Tooltip>
	);

	const renderPhone = (phone: string) => (
		<a href={`tel:${phone}`}>{renderText(phone, 'sapphirine')}</a>
	);

	const renderStatus = (status: string) => renderText(status, 'sapphirine');

	const renderLink = (link: string) => (
		<a
			href={!link.includes('http:') ? link : `https://${link}`}
			target="_blank"
			rel="noopener noreferrer"
		>
			{renderText(link, 'sapphirine')}
		</a>
	);

	const renderCell = (cell: string) => renderText(cell, 'black');

	const renderHighlight = (cell: string) => (
		<div
			style={{
				padding: '6px 0',
				width: 120,
				background: window.innerWidth >= 768 ? 'none' : colors.blueStatus,
				borderRadius: 10,
				textAlign: 'center',
			}}
		>
			{renderText(cell, window.innerWidth >= 768 ? 'black' : 'white')}
		</div>
	);

	const renderItem = (item: string, title: string) => {
		if (!!item && item.match(RE_EMAIL)) return renderEmail(item);
		if (!!item && item.match(RE_PHONE)) return renderPhone(item);
		if (!!item && item.match(RE_URL)) return renderLink(item);
		if (!!item && title === highlight) return renderHighlight(item);
		if (!!item && title === 'Status') return renderStatus(item);
		return renderCell(item);
	};

	return titles.map((title: any, i: any) => (
		<td key={i}>
			{renderItem(
				item[title.original] ? String(item[title.original]) : '---',
				title.original
			)}
		</td>
	));
};

export default React.memo(TableItem);
